<template>
  <div class="container">
    <div class="content animate__animated animate__fadeIn">
      <div class="title">
        <img src="../assets/img/cc.png" class="titleimg" />
      </div>
      <div class="circleBox">
        <div class="d1">
          <div class="ex1"></div>
          <div class="ex2"></div>
          <div class="ex3"></div>
          <div class="ex4"></div>
        </div>
        <div class="d2">
          <div class="d2_c d2_c1"><span>消费</span><span>三产</span></div>
          <div class="d2_c d2_c2"><span>加工</span><span>二产</span></div>
          <div class="d2_c d2_c3"><span>种植</span><span>一产</span></div>
        </div>
        <div class="d3">
          <div class="ex1"></div>
          <div class="ex2"></div>
          <div class="ex3"></div>
          <div class="ex4"></div>
        </div>
        <div class="d4">
          <div class="ex1"></div>
          <div class="ex2"></div>
          <div class="ex3"></div>
          <div class="ex4"></div>
        </div>
        <!-- <div class="d5">
          <div class="ex1"></div>
          <div class="ex2"></div>
          <div class="ex3"></div>
          <div class="ex4"></div>
        </div> -->

        <div class="d1_1"> 
          <div class="d1_1_1" v-for="(item, index) in d1data" :key="index">
            <router-link :to="{path:'/'+item.path}">
            <img :src="item.img" />
            <h6>{{ item.name }}</h6>
            </router-link>
          </div>
          
        </div>
        <div class="d2_2">
          <div class="d2_2_1" v-for="(item, index) in d2data" :key="index">
            <router-link :to="{path:'/'+item.path}">
            <img :src="item.img" />
            <h6>{{ item.name }}</h6>
            </router-link>
          </div>
        </div>
        <div class="d3_3">
          <div class="d3_3_1" v-for="(item, index) in d3data" :key="index">
            <router-link :to="{path:'/'+item.path}">
            <img :src="item.img" />
            <h6>{{ item.name }}</h6>
            </router-link>
          </div>
        </div>
        <!-- <div class="d4_4">
          <div class="d4_4_1" v-for="(item, index) in d4data" :key="index">
            <img :src="item.img" />
            <h6>{{ item.name }}</h6>
          </div>
        </div> -->
        <!-- <img src="../assets/img/syjg/jiantou.gif" class="jiantou1" /> -->
        <div>消费带动加工</div>
      </div>

      <img src="../assets/img/gx.png" class="bottom" />
      <!-- <img src="../assets/img/gx.png" class="bottom1" /> -->
    </div>
    <div id="iviewBg" class="bolang"></div>
  </div>
  <!-- <div class="bg" v-if="isShow"><img src="../assets/img/bg.gif" /></div> -->
  <!-- <img src="../assets/images/bg.gif" /> -->
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from "three";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";

import { setInterval, clearInterval } from "timers";
import { stat } from "fs";

// import waterimg from "@/assets/img/ldz1.png"

export default {
  name: "Home",
  props: {
    //控制x轴波浪的长度
    amountX: {
      type: Number,
      default: 50,
    },
    //控制y轴波浪的长度
    amountY: {
      type: Number,
      default: 30,
    },
    //控制点颜色
    color: {
      type: String,
      default: "#67F2EB",
    },
    //控制波浪的位置
    top: {
      type: Number,
      default: 350,
    },
  },
  setup(props) {
    const SEPARATION = 90;

    // let stats;
    let container, camera, scene, renderer;

    let particles,
      count = 0;

    let mouseX = 0;

    let windowHalfX = window.innerWidth / 2;

    const { proxy } = getCurrentInstance();
    const timer = ref(null);
    const state = reactive({
      currentTime: "",
      d1data: [
        {
          name: "电商直播",
          img: require("@/assets/img/home/1.jpg"),
          path:"zhibo"
        },
        {
          name: "电商数据",
          img: require("@/assets/img/home/2.jpg"),
          path:"xiaofeiData"
        },
        {
          name: "电商产品",
          img: require("@/assets/img/home/3.jpg"),
          path:"xiaofeiChanpin"
        },
      ],
      d2data: [
        {
          name: "加工",
          img: require("@/assets/img/home/4.jpg"),
          path:"jiagong"
        },
        {
          name: "车间",
          img: require("@/assets/img/home/5.jpg"),
          path:"chejian"
        },
        {
          name: "监控",
          img: require("@/assets/img/home/6.jpg"),
          path:"kshyqjk"
        },
      ],
      d3data: [
        {
          name: "高标准农田",
          img: require("@/assets/img/home/7.jpg"),
          path:"plant"
        },
        {
          name: "智能灌溉",
          img: require("@/assets/img/home/10.jpg"),
          path:"zhinengGG"
        },
        {
          name: "农业溯源",
          img: require("@/assets/img/home/12.jpg"),
          path:"suyuan"
        },
      ],
      // d4data: [
      //   {
      //     name: "智能灌溉",
      //     img: require("@/assets/img/home/10.jpg"),
      //   },
      //   {
      //     name: "种植模型",
      //     img: require("@/assets/img/home/11.jpg"),
      //   },
      //   {
      //     name: "农业溯源",
      //     img: require("@/assets/img/home/12.jpg"),
      //   },
      // ],
      videoShow: false,
      options: {
        src: "", //视频源
        type: "m3u8", //视频类型
      },
      isShow: false,
    });
    onMounted(() => {
      clearInterval(timer.value);
      timer.value = setInterval(() => {
        state.currentTime = proxy.$utils.getCurrentTime();
      }, 1000);
      setTimeout(() => {
        state.isShow = true;
      }, 3000);

      // getData();

      init();
      animate();
    });

    onBeforeUnmount(() => {
      clearInterval(timer.value);
    });
    const onPlay = (ev) => {
      console.log("播放");
    };

    function getData() {
      axios
        .post("https://farmmanagement.laicunwang.com/api/index/hqhzsindex", {
          sign: "c4c6cff9b7ec6b87fa953f77ec7e624b",
        })
        .then((res) => {
          console.log(res);
          let data = res.data.data;
          // 左一
          state.leftData = data[0];
          // 左二
          state.cangchuList = [
            { id: 1, name: "库存量", value: data[1].kcl },
            { id: 2, name: "入库量", value: data[1].rkl },
            { id: 3, name: "出库量", value: data[1].ckl },
          ];
          state.left2Data = [data[1].sz, data[1].bz];
          // 左三

          // 中间一
          // 处理数据
          let centerData1 = [
            { id: 1, name: "种植面积/亩", value: data[2].zzmj },
            { id: 2, name: "产品预测/吨", value: data[2].cpyc },
            { id: 3, name: "花生出库量/吨", value: data[2].hsck },
            { id: 4, name: "服务人数/人", value: data[2].fwrs },
            { id: 5, name: "处理问题/条", value: data[2].clwt },
          ];
          centerData1.forEach((item) => {
            // let value = getNum(item.value)
            item.arr = getNum(item.value);
          });
          state.centerData1 = centerData1;
          // 视频
          state.options.src = data[3].sxt;
          //  state.options.src= "https://cdn.jsdelivr.net/gh/xdlumia/files/video-play/IronMan.mp4"
          // 中间二
          let center3Data = [
            { id: 1, name: "技术指导", value: data[4].jszd, dw: "人" },
            { id: 2, name: "花生代卖", value: data[4].hsdm, dw: "吨" },
            { id: 3, name: "服务企业", value: data[4].fwqy, dw: "家" },
          ];
          center3Data.forEach((item) => {
            // let value = getNum(item.value)
            item.arr = getNum(item.value);
          });
          state.center3Data = center3Data;
          // 中间
          state.center4Data = [
            { id: 1, tit: "巡田问题", pro: data[5].xtwe },
            { id: 2, tit: "问题分析", pro: data[5].xtwtfx },
            { id: 3, tit: "作业指令", pro: data[5].zyzl },
          ];
          //  右一
          // state.right1Data = [
          //   {id:1,name:"空气温度",value:data[6].cgq.kqwd,unit:"℃",icon:require('../assets/images/jc1.png')},
          //   {id:2,name:"空气湿度",value:data[6].cgq.kqsd,unit:"%",icon:require('../assets/images/jc2.png')},
          //   {id:3,name:"土壤湿度",value:data[6].cgq.trsd,unit:"%",icon:require('../assets/images/jc3.png')},
          //   {id:4,name:"土壤温度",value:data[6].cgq.trwd,unit:"℃",icon:require('../assets/images/jc4.png')},
          //   {id:5,name:"光照",value:data[6].cgq.kqgz,unit:"lux",icon:require('../assets/images/jc5.png')},
          //   {id:6,name:"ph值",value:data[6].cgq.trph,unit:"",icon:require('../assets/images/jc6.png')},
          //   {id:7,name:"氮",value:data[6].cgq.trdhl,unit:"mg/kg",icon:require('../assets/images/jc7.png')},
          //   {id:8,name:"磷",value:data[6].cgq.trlhl,unit:"mg/kg",icon:require('../assets/images/jc7.png')},
          //   {id:9,name:"钾",value:data[6].cgq.trjhl,unit:"mg/kg",icon:require('../assets/images/jc7.png')},
          //   {id:10,name:"风速",value:data[6].cgq.kqfs,unit:"m/s",icon:require('../assets/images/jc10.png')},
          //   {id:11,name:"雨量",value:data[6].cgq.kqyl,unit:"mm",icon:require('../assets/images/jc11.png')},
          //   {id:12,name:"风向",value:data[6].cgq.kqfx,unit:"",icon:require('../assets/images/jc12.png')},
          // ]
          //  右二
          // state.right2Data = [
          //   {id:1,name:"土壤壤情预警",value:data[6].trxqyj,icon:require('../assets/images/tr.png')},
          //   {id:2,name:"农作物苗情预警",value:data[6].nzwnqyj,icon:require('../assets/images/mq.png')},
          //   {id:3,name:"病虫害灾害预警",value:data[6].bchyj,icon:require('../assets/images/bc.png')},
          //   {id:4,name:"气象灾害预警",value:data[6].qxzhyj,icon:require('../assets/images/qx.png')},
          // ]
        });
    }

    function tapVideoShow() {
      state.videoShow = true;
    }

    function init() {
      container = document.createElement("div");
      document.getElementById("iviewBg").appendChild(container);

      //创建透视相机
      camera = new THREE.PerspectiveCamera(
        75, //摄像机视锥体垂直视野角度
        window.innerWidth / window.innerHeight, //摄像机视锥体长宽比
        1, //摄像机视锥体近端面
        10000 //摄像机视锥体远端面
      );

      //设置相机z轴视野
      camera.position.z = 1500;

      //创建场景
      scene = new THREE.Scene();

      const numParticles = props.amountX * props.amountY;

      const positions = new Float32Array(numParticles * 3);
      const scales = new Float32Array(numParticles);

      let i = 0,
        j = 0;

      // 初始化粒子位置和大小
      for (let ix = 0; ix < props.amountX; ix++) {
        for (let iy = 0; iy < props.amountY; iy++) {
          positions[i] = ix * SEPARATION - (props.amountX * SEPARATION) / 2; // x
          positions[i + 1] = 0; // y
          positions[i + 2] = iy * SEPARATION - (props.amountY * SEPARATION) / 2; // z
          scales[j] = 1;
          i += 3;
          j++;
        }
      }

      //是面片、线或点几何体的有效表述。包括顶点位置，面片索引、法相量、颜色值、UV 坐标和自定义缓存属性值。使用 BufferGeometry 可以有效减少向 GPU 传输上述数据所需的开销
      const geometry = new THREE.BufferGeometry();
      geometry.setAttribute(
        "position",
        new THREE.BufferAttribute(positions, 3)
      );
      geometry.setAttribute("scale", new THREE.BufferAttribute(scales, 1));

      //着色器材质(ShaderMaterial),设置球的大小，颜色，等
      const material = new THREE.ShaderMaterial({
        uniforms: {
          //设置球的颜色
          color: { value: new THREE.Color(props.color) },
        },
        //控制球的大小
        vertexShader:
          "attribute float scale; void main() {vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );gl_PointSize = scale * ( 200.0 / - mvPosition.z );gl_Position = projectionMatrix * mvPosition;}",
        fragmentShader:
          "uniform vec3 color;void main() {if ( length( gl_PointCoord - vec2( 0.5, 0.5 ) ) > 0.475 ) discard;gl_FragColor = vec4( color, 1.0 );}",
      });

      //一个用于显示点的类。
      particles = new THREE.Points(geometry, material);
      //往场景中添加点
      scene.add(particles);

      //alpha - canvas是否包含alpha (透明度)。默认为 false。
      //渲染器的背景色默认为黑色，设置渲染器的背景色为透明
      renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setClearAlpha(0);
      renderer.setSize(window.innerWidth, window.innerHeight);
      container.appendChild(renderer.domElement);

      //显示右上角fps框
      // stats = new Stats();
      //   container.appendChild(stats.dom);

      container.style.touchAction = "none";
      //监听鼠标移动事件
      container.addEventListener("pointermove", onPointerMove);

      //调整波浪的位置
      container.style.position = "relative";
      container.style.top = `${props.top}px`;

      window.addEventListener("resize", onWindowResize);
    }

    function render() {
      camera.position.x += (mouseX - camera.position.x) * 0.05;
      camera.position.y = 400;
      camera.lookAt(scene.position);

      const positions = particles.geometry.attributes.position.array;
      const scales = particles.geometry.attributes.scale.array;

      // 设置粒子位置和大小
      let i = 0,
        j = 0;
      for (let ix = 0; ix < props.amountX; ix++) {
        for (let iy = 0; iy < props.amountY; iy++) {
          positions[i + 1] =
            Math.sin((ix + count) * 0.3) * 50 +
            Math.sin((iy + count) * 0.5) * 50;

          scales[j] =
            (Math.sin((ix + count) * 0.3) + 1) * 10 +
            (Math.sin((iy + count) * 0.5) + 1) * 10;

          i += 3;
          j++;
        }
      }

      particles.geometry.attributes.position.needsUpdate = true;
      particles.geometry.attributes.scale.needsUpdate = true;

      renderer.render(scene, camera);

      count += 0.1;
    }

    function onWindowResize() {
      windowHalfX = window.innerWidth / 2;
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    }

    //监听鼠标移动事件
    function onPointerMove(event) {
      console.log(event);
      if (event.isPrimary === false) return;
      mouseX = event.clientX - windowHalfX;
    }

    function animate() {
      requestAnimationFrame(animate);
      render();
      //fps 实时更新
      // stats.update();
    }

    return {
      ...toRefs(state),

      timer,
      getData,
      onPlay,
      tapVideoShow,
      init,
      render,
      onWindowResize,
      onPointerMove,
      animate,
    };
  },
  components: {},
};
</script>
<style lang="less" scoped>
.jiantou1{
  width: 100px;
  transform: rotate(270deg);
}
.bg {
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  img {
    width: 500px;
  }
}
#iviewBg {
  width: 100%;
  height: 100vh;
  // background: url("../src/assets/gx.png") no-repeat;
  overflow: hidden;
  // background: #000;
  position: absolute;
  top: 0;
  left: 0;
}
.container {
  width: 100%;
  height: 100%;
  background: url("../assets/img/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  color: #fff;
  position: relative;
  // z-index: 9999;
}
.content {
  width: 100%;
  height: 100%;
  background: url("../assets/img/bt.png") no-repeat top center;
  background-size: 100% 100%;
  color: #fff;
  position: relative;
  z-index: 9999;
  .bottom {
    width: 100%;
    height: 243px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .bottom1 {
    width: 100%;
    height: 243px;
    position: absolute;
    bottom: 0;
    left: 0;
    -webkit-animation: guangying 2s alternate infinite;
    animation: guangying 2s alternate infinite;
    opacity: 0.5;
  }
  .title {
    width: 100%;
    height: 80px;
    animation: yinying 2s linear infinite;
    overflow: hidden;
    .titleimg {
      opacity: 0.5;
      width: 300px;
      margin-top: 30px;
    }
  }

  .circleBox {
    width: 100%;
    height: calc(100% - 94px);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 35px;

    .d1 {
      width: 80px;
      height: 300px;
      // background: url("../assets/img/syjg/z.png") no-repeat top center;
      // background-size: 100% 100%;
      position: absolute;
      left: 469px;
      top: 329px;
      .ex1 {
        width: 55px;
        height: 1px;
        background-color: #3fe1c6;
        position: absolute;
        top: 0;
        right: 0;
      }
      .ex2 {
        width: 1px;
        height: 300px;
        background-color: #3fe1c6;
        position: absolute;
        top: 0;
        right: 0;
      }
      .ex3 {
        width: 55px;
        height: 1px;
        background-color: #3fe1c6;
        position: absolute;
        bottom: 50%;
        right: 0;
      }
      .ex4 {
        width: 55px;
        height: 1px;
        background-color: #3fe1c6;
        position: absolute;
        bottom: 0;
        right: 0;
      }
      // transform: scale(0.8);
    }
    .d2 {
      width: 780px;
      height: 358px;
      background: url("../assets/img/syjg/jg.png") no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      left: 50%;
      top: 24%;
      margin-left: -390px;
      // transform: scale(1.3);
      // border: #028ba0 1px solid;
      display: flex;
      justify-content: space-between;
      padding: 110px;
      .d2_c{
        width: 33%;
        display: flex;
        flex-direction: column;
        position: absolute;
        span{
          display: block;
          font-size: 28px;
        }
      }
      .d2_c1{
        top: 24%;
        left: 80px;
        span:nth-child(2){
          margin-top: 90px;
        }
      }
      .d2_c2{
        top: 36%;
        left: 275px;
        span:nth-child(2){
          margin-top: 80px;
        }
      }
      .d2_c3{
        top: 24%;
        right: 53px;
        span:nth-child(2){
          margin-top: 80px;
        }
      }
    }
    .d3 {
      width: 600px;
      height: 60px;
      // background: url("../assets/img/syjg/x.png") no-repeat top center;
      // background-size: 100% 100%;
      position: absolute;
      left: 50%;
      top: 625px;
      margin-left: -300px;

      .ex1 {
        width: 1px;
        height: 60px;
        background-color: #3bc1f9;
        position: absolute;
        top: 0;
        left: 0;
      }
      .ex2 {
        width: 600px;
        height: 1px;
        background-color: #3bc1f9;
        position: absolute;
        top: 0;
        right: 0;
      }
      .ex3 {
        width: 1px;
        height: 60px;
        background-color: #3bc1f9;
        position: absolute;
        top: 0;

        right: 0;
      }
      .ex4 {
        width: 1px;
        height: 60px;
        background-color: #3bc1f9;
        position: absolute;
        top: 0;

        left: 50%;
      }
    }
    .d4 {
      width: 80px;
      height: 300px;
      // background: url("../assets/img/syjg/y.png") no-repeat top center;
      // background-size: 100% 100%;
      position: absolute;
      right: 469px;
      top: 329px;
      transform: rotateY(180deg);
      .ex1 {
        width: 55px;
        height: 1px;
        background-color: #3fe1c6;
        position: absolute;
        top: 0;
        right: 0;
      }
      .ex2 {
        width: 1px;
        height: 300px;
        background-color: #3fe1c6;
        position: absolute;
        top: 0;
        right: 0;
      }
      .ex3 {
        width: 55px;
        height: 1px;
        background-color: #3fe1c6;
        position: absolute;
        bottom: 50%;
        right: 0;
      }
      .ex4 {
        width: 55px;
        height: 1px;
        background-color: #3fe1c6;
        position: absolute;
        bottom: 0;
        right: 0;
      }
      // transform: scale(0.8);
    }
    .d5 {
      width: 80px;
      height: 359px;
      // background: url("../assets/img/syjg/y.png") no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      right: 270px;
      top: 230px;
      // transform: scale(0.8);
      transform: rotateY(180deg);
      .ex1 {
        width: 55px;
        height: 1px;
        background-color: #3fe1c6;
        position: absolute;
        top: 0;
        right: 0;
      }
      .ex2 {
        width: 1px;
        height: 359px;
        background-color: #3fe1c6;
        position: absolute;
        top: 0;
        right: 0;
      }
      .ex3 {
        width: 55px;
        height: 1px;
        background-color: #3fe1c6;
        position: absolute;
        bottom: 180px;
        right: 0;
      }
      .ex4 {
        width: 55px;
        height: 1px;
        background-color: #3fe1c6;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
    .d1_1 {
      width: 240px;
      height: 450px;
      position: absolute;
      // border: #fff 1px solid;
      display: flex;
      flex-direction: column;
      top: 277px;
      left: 245px;
      .d1_1_1 {
        width: 100%;
        height: 78px;
        margin-top: 20px;
        // border: #fff 1px solid;
        position: relative;

        img {
          width: 130px;
          height: 78px;
          position: absolute;
          left: 0;
          top: 0;
          border: 2px solid #45e1c9;
          padding: 5px 5px;
          border-radius: 5px;
        }
        h6 {
          width: 80px;
          height: 30px;
          border-radius: 5px;
          border: #45e1c9 1px solid;
          font-size: 13px;
          color: #fff;
          position: absolute;
          right: 0;
          top: 21%;
          line-height: 30px;
          font-weight: normal;
        }
      }
      .d1_1_1:first-child {
        top: 0;
      }
      .d1_1_1:nth-child(2) {
        top: 52px;
      }
      .d1_1_1:nth-child(3) {
        bottom: -104px;
      }
    }
    .d2_2 {
      width: 850px;
      height: 160px;
      position: absolute;
      top: 637px;
      left: 50%;
      z-index: 9999;
      margin-left: -425px;
      // border: #fff 1px solid;
      display: flex;
      .d2_2_1 {
        width: 130px;
        height: 160px;
        // margin-left: 20px;
        position: absolute;

        img {
          width: 130px;
          height: 78px;
          position: absolute;
          left: 0;
          top: 62px;
          border: 2px solid #45e1c9;
          padding: 5px 5px;
          border-radius: 5px;
        }
        h6 {
          width: 80px;
          height: 30px;
          border-radius: 5px;
          border: #45e1c9 1px solid;
          font-size: 13px;
          color: #fff;
          position: absolute;
          right: 25px;
          top: 13px;
          line-height: 30px;
          font-weight: normal;
        }
      }
      .d2_2_1:first-child {
        top: 40px;
        left: 60px;
      }
      .d2_2_1:nth-child(2) {
        top: 40px;
        left: 50%;
        margin-left: -65px;
      }
      .d2_2_1:nth-child(3) {
        top: 40px;
        right: 57px;
      }
    }

    .d3_3 {
      width: 240px;
      height: 500px;
      position: absolute;
      // border: #fff 1px solid;
      display: flex;
      flex-direction: column;
      top: 274px;
      right: 245px;
      .d3_3_1 {
        width: 100%;
        height: 78px;
        margin-top: 20px;
        // border: #fff 1px solid;
        position: relative;

        img {
          width: 130px;
          height: 78px;
          position: absolute;
          right: 0;
          top: 0;
          border: 2px solid #45e1c9;
          padding: 5px 5px;
          border-radius: 5px;
        }
        h6 {
          width: 80px;
          height: 30px;
          border-radius: 5px;
          border: #45e1c9 1px solid;
          font-size: 13px;
          color: #fff;
          position: absolute;
          left: 0;
          top: 24px;
          line-height: 30px;
          font-weight: normal;
        }
      }
      .d3_3_1:first-child {
        top: -5px;
        left: 0;
      }
      .d3_3_1:nth-child(2) {
        top: 44px;
        left: 0;
      }
      .d3_3_1:nth-child(3) {
        bottom: -98px;
        left: 0;
      }
    }
    .d4_4 {
      width: 240px;
      height: 500px;
      position: absolute;
      // border: #fff 1px solid;
      display: flex;
      flex-direction: column;
      top: 177px;
      right: 206px;
      .d4_4_1 {
        width: 100%;
        height: 68px;
        margin-top: 20px;
        // border: #fff 1px solid;
        position: relative;

        img {
          width: 130px;
          height: 78px;
          position: absolute;
          right: 0;
          top: 0;
          border: 2px solid #45e1c9;
          padding: 5px 5px;
          border-radius: 5px;
        }
        h6 {
          width: 80px;
          height: 30px;
          border-radius: 5px;
          border: #45e1c9 1px solid;
          font-size: 13px;
          color: #fff;
          position: absolute;

          left: 0;
          top: 24px;
          line-height: 30px;
          font-weight: normal;
        }
      }
      .d4_4_1:first-child {
        top: -5px;
        left: 0;
      }
      .d4_4_1:nth-child(2) {
        top: 84px;
        left: 0;
      }
      .d4_4_1:nth-child(3) {
        top: 174px;
        left: 0;
      }
    }
  }
}

@keyframes bianda {
  /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0% {
    transform: scale(0.8);
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  // 50%{
  //   transform: scale(1);
  // }
  100% {
    transform: scale(1);
  }
}

@keyframes yinying {
  /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0% {
    mask: linear-gradient(135deg, #028ba0 40%, #028ba0, #eefafe 60%);
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  100% {
    mask: linear-gradient(0deg, #028ba0 0%, #028ba0, #eefafe 60%);
  }
}

@keyframes jiantou {
  /*引用动画名称*/
  0% {
    padding: 0;
  }
  50% {
    padding: 10px;
  }

  100% {
    padding-top: 0;
  }
}
/* 定义关键帧 */
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
/* 定义关键帧 */
@keyframes opacity {
  /*引用动画名称*/
  0% {
    opacity: 0.5;
    //filter: drop-shadow(0 0 50px rgba(35, 151, 157, 1));
  }

  50% {
    opacity: 1;
    //  filter: drop-shadow(0 0 20px rgba(0, 0, 0, 0.5));
  }
  100% {
    opacity: 0.5;
    //filter: drop-shadow(0 0 20px rgba(0, 0, 0, 0));
  }
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}
</style>
